import API from "./api";

export const uploadOfferLetter = async ({
  applicationId,
  candidateId,
  employmentType,
  location,
  dateOfJoining,
  workMode,
  offerLetter,
}) => {
  const formData = new FormData();

  formData.append("applicationId", applicationId);
  formData.append("candidateId", candidateId);
  formData.append("employmentType", employmentType);
  formData.append("location", location);
  formData.append("dateOfJoining", dateOfJoining);
  formData.append("workMode", workMode);
  formData.append("offerLetter", offerLetter);

  const response = await API.post("/offer/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const releaseManualOfferLetter = async ({
  name,
  email,
  candidateId,
  job,
  employmentType,
  workLocation,
  location,
  dateOfJoining,
  workMode,
  offerLetter,
}) => {
  const formData = new FormData();

  formData.append("name", name);
  formData.append("email", email);
  formData.append("candidateId", candidateId);
  formData.append("job", job);
  formData.append("employmentType", employmentType);
  formData.append("workLocation", workLocation);
  formData.append("location", location);
  formData.append("dateOfJoining", dateOfJoining);
  formData.append("workMode", workMode);
  formData.append("offerLetter", offerLetter);

  const response = await API.post("/manual-offer/release", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
